module.exports = __webpack_public_path__ + "img/522395grupo-prisa.dc0552fe.jpg";